import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'fs-snap-ai-image-dialog',
  templateUrl: './snap-ai-image-dialog.component.html',
  styleUrls: ['./snap-ai-image-dialog.component.scss'],
})
export class SnapAiImageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
